import React from 'react';
import { Link } from 'react-router-dom';
import { Link as RouteLink } from 'react-scroll';
import { FaGithubAlt, FaLinkedinIn, FaCodepen } from 'react-icons/fa';
import { AboutStyles } from '../styles/about.style';
import profile from '../images/profile-picture2.png';
import FmIcon from '../images/vectors/FmIcon';
import Skills from './Skills';

const About = ({ onInputFocus }) => {
    return (
        <AboutStyles id="about">
            <div className="container">
                <div className="row">
                    <div className="section__title">
                        <h2 data-heading="Meet me">About me</h2>
                    </div>
                    <div className="row">
                        <div className="about__img">
                            <div className="img-box inner-shadow">
                                <img src={profile} alt="Johnpaul's profile" className="outside-shadow" />
                            </div>
                            <div className="social__links">
                            <Link 
                                to={{pathname: 'https://github.com/Johnpaul-Attamah'}} 
                                target="_blank"
                                className="outside-shadow hover-in-shadow"
                            >
                                <FaGithubAlt/>
                            </Link>
                            <Link 
                                to={{pathname: 'https://www.linkedin.com/in/johnpaul-attamah-4b265983/'}} 
                                target="_blank"
                                className="outside-shadow hover-in-shadow"
                            >
                                <FaLinkedinIn/>
                            </Link>
                            <Link 
                                to={{pathname: 'https://codepen.io/BORREE'}} 
                                target="_blank"
                                className="outside-shadow hover-in-shadow"
                            >
                                <FaCodepen/>
                            </Link>
                            <Link 
                                to={{pathname: 'https://www.frontendmentor.io/profile/Johnpaul-Attamah'}} 
                                target="_blank"
                                className="outside-shadow hover-in-shadow fmicon"
                            >
                                <FmIcon/>
                            </Link>
                            </div>
                        </div>
                        <div className="about__info">
                            <p><span>I'm a web developer in Enugu, Nigeria, looking for new opportunities to maximize potentials. </span>I have serious passion for UI effects, animations and creating intuitive, dynamic user experiences. I find joy in  building excellent softwares that improve the lives of those around me. I enjoy working with people who are solving big problems in new and exciting ways.</p>
                            <Link 
                                className="btn-link outside-shadow hover-in-shadow"
                                to="/files/jp_cv.pdf" 
                                target="_blank"
                                download
                            >
                                Download Cv
                            </Link>
                            <RouteLink
                                onClick={onInputFocus}
                                to="contact"
                                spy={true}
                                smooth={true}
                                offset={-70}
                                duration={500}
                                className="btn-link outside-shadow hover-in-shadow"
                                activeClass="active" 
                            >
                                Hire me
                            </RouteLink>
                        </div>
                    </div>
                </div>
                <Skills/>
            </div>
        </AboutStyles>
    )
}

export default About;
